import { useEffect, useState } from 'react'
import { Tutorial } from './Tutorial.tsx'
import { loadTutorial, getTutorial } from './tutorials/index.ts'

interface TutorialPageProps {
  id: string
}

export function TutorialPage({ id }: TutorialPageProps) {
  const [markdown, setMarkdown] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true)
        setError(null)
        const tutorial = getTutorial(id)
        if (!tutorial) {
          setError(`Tutorial "${id}" not found`)
          setLoading(false)
          return
        }
        const content = await loadTutorial(id)
        setMarkdown(content)
      }
      catch (err: any) {
        setError(err.message || 'Failed to load tutorial')
      }
      finally {
        setLoading(false)
      }
    }

    if (!id) {
      setError('No tutorial ID provided')
      setLoading(false)
      return
    }

    load()
  }, [id])

  if (loading) {
    return (
      <div className="w-[100dvw] h-[100dvh] flex items-center justify-center text-[#f0f0f0]">
        <div className="text-center">
          <div className="text-xl mb-4">Loading tutorial...</div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="w-[100dvw] h-[100dvh] flex items-center justify-center text-[#f0f0f0]">
        <div className="text-center">
          <div className="text-xl mb-4 text-red-400">Error</div>
          <div className="text-[#e0e0e0]">{error}</div>
        </div>
      </div>
    )
  }

  if (!markdown) {
    return null
  }

  return <Tutorial markdown={markdown} tutorialId={id} />
}

